import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { UseGlobellogin } from "./Logincontaxt.jsx/Logincontex";
import { BASE_URL } from "../Config/Config";
import { RECAPTCHA_SITE_KEY } from "./GlobelHelper/GlobelRechpcha";
import { NavLink } from "react-router-dom";
import GoogleSignin from "./Googlesignup";
import styled from "styled-components";
import SubLoading from "../ALL CSS/Loading";

const Signin = ({ setIsSignin, toggleForm }) => {
  const { setsuccessfully } = UseGlobellogin();

  const [data, setData] = useState({
    user_input: "",
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [formMessage, setFormMessage] = useState("");
  const [loading, setLoading] = useState(false);


  const updateInput = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCaptchaChange = (value) => {
    if (value) setEnableSubmit(false);
  };

  const isEmail = (value) => /^\S+@\S+\.\S+$/.test(value);
  const isMobile = (value) => /^[6-9]\d{9}$/.test(value);

  const validateForm = () => {
    const newErrors = {};
    const { user_input, password } = data;

    if (!user_input.trim()) {
      newErrors.user_input = "Please enter your email or mobile number.";
    } else if (!isEmail(user_input) && !isMobile(user_input)) {
      newErrors.user_input = "Enter a valid email or 10-digit mobile number.";
    }

    if (!password.trim()) {
      newErrors.password = "Please enter your password.";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    setFormMessage("");
    try {
      const response = await fetch(`${BASE_URL}/usersignup/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (response.ok) {
        setsuccessfully(result.message);
        setTimeout(() => setsuccessfully(""), 10000);
        setData({ user_input: "", password: "" });
        setFormMessage("");
        setIsSignin(false);
      } else {
        setFormMessage(result.message || result.error);
        setsuccessfully(result.error || result.message);

      }
    } catch (err) {
      setFormMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <section className="auth-section auth-fullscreen">
        <div className="p-0">
          <div className="text-center">
            <h4 className="display-5 fw-bold p-0">Sign Up</h4>
            <div className="text-center mb-4 px-4">
              <p className="text-lg font-semibold text-gray-800 leading-snug text-primary">
                Welcome to <span className="text-indigo-600 font-bold">Auratech</span> — your gateway to smart learning & seamless tech solutions. Let’s grow together!
              </p>
              <p>
                Already have an account?{" "}
                <span
                  className="text-primary"
                  style={{ cursor: "pointer", fontWeight: 700 }}
                  onClick={() => setIsSignin(false)}
                >
                  Login
                </span>
              </p>
            </div>
          </div>

          <div className="row justify-content-center g-0">
            <div className="col-12 col-lg-10 col-xl-10">
              <div className="row align-items-stretch g-0">
                {/* Form Section */}
                <div className="col-12 col-lg-6 mb-4 mb-lg-0 order-3 order-lg-1">
                  <div className="login-card p-4 p-md-5 h-100 d-flex flex-column justify-content-center">
                    <form onSubmit={handleSubmit} noValidate>
                      {/* Email / Mobile */}
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className={`form-control ${errors.user_input ? "is-invalid" : data.user_input ? "is-valid" : ""
                            }`}
                          id="user_input"
                          name="user_input"
                          placeholder="Email or Mobile Number"
                          value={data.user_input}
                          onChange={updateInput}
                          required
                        />
                        <label htmlFor="user_input">Email or Mobile Number</label>
                        {errors.user_input && (
                          <div className="invalid-feedback">{errors.user_input}</div>
                        )}
                      </div>

                      {/* Password */}
                      <div className="form-floating mb-3">
                        <input
                          type="password"
                          className={`form-control ${errors.password ? "is-invalid" : data.password ? "is-valid" : ""
                            }`}
                          id="password"
                          name="password"
                          placeholder="Password"
                          value={data.password}
                          onChange={updateInput}
                          required
                        />
                        <label htmlFor="password">Password</label>
                        {errors.password && (
                          <div className="invalid-feedback">{errors.password}</div>
                        )}
                      </div>

                      {formMessage && (
                        <div className="text-danger fw-bold mb-3 text-center">
                          {formMessage}
                        </div>
                      )}

                      <div className="mb-3 d-flex justify-content-start">
                        <div style={{ transform: "scale(0.75)", transformOrigin: "0 0" }}>
                          <ReCAPTCHA
                            sitekey={RECAPTCHA_SITE_KEY}
                            onChange={handleCaptchaChange}
                          />
                        </div>
                      </div>

                      <div className="btn-group d-grid">
                        <button
                          className="th-btn style3"
                          type="submit"
                          disabled={enableSubmit}
                        >
                          {
                            loading ? (
                              <>
                                <div className="d-flex justify-content-center gap-2 align-items-center">
                                  Processing...
                                  <SubLoading />
                                </div>

                              </>
                            ) : (
                              <>

                                Sign Up <i className="fas fa-arrow-right ms-2" />
                              </>
                            )
                          }

                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Divider */}
                {/* <div className="col-12 col-lg-1 d-flex flex-column align-items-center justify-content-center order-2 order-lg-2">
                  <span className="my-2 fw-bold">OR</span>
                </div> */}
                  <div className="col-12 col-lg-1 d-flex flex-column align-items-center justify-content-center order-2 order-lg-2">
        <div className="d-lg-block d-none bg-dark" style={{ width: 1, height: "100%", opacity: 0.3 }} />
        <div className="d-lg-none d-block bg-dark" style={{ width: "100%", height: 1, opacity: 0.3 }} />
        <span className="my-2 text-uppercase fw-bold ">or</span>
        <div className="d-lg-block d-none bg-dark" style={{ width: 1, height: "100%", opacity: 0.3 }} />
        <div className="d-lg-none d-block bg-dark" style={{ width: "100%", height: 1, opacity: 0.3 }} />
      </div>

                {/* Social Login */}
                <div className="col-12 col-lg-4 order-1 order-lg-2">
                  <div className="sigin-card d-flex flex-column align-items-center justify-content-evenly h-100 p-4">
                    <NavLink to="/" className="mobile-logo">
                      <img
                        src="/assets/img/AA_LOgo_Black.png"
                        alt="Auratech Academy"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </NavLink>
                    <GoogleSignin mode="Signup" toggleForm={toggleForm} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .auth-section {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
  }

  .login-card {
    border: 1px solid #b3cae0ff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border-radius: 12px;
    transition: all 0.4s ease;
  }

  .login-card:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-6px);
  }

  .form-control.is-invalid {
    border-color: #dc3545;
  }
  .form-control.is-valid {
    border-color: #198754;
  }

  .invalid-feedback {
    color: #dc3545;
    font-size: 0.875rem;
    margin-top: 4px;
  }

  .text-danger {
    font-size: 0.95rem;
  }

  .th-btn {
    transition: all 0.3s;
  }
  .th-btn:hover {
    background-color: #084298;
    transform: translateY(-2px);
  }
`;

export default Signin;
